export default __webpack_public_path__ + "static/jwPlayer-b2e8e850d2d7293cb62d2f7fe7f34860.svg";